import { useState, useEffect } from 'react';
import Input from '@components/ui/Input';
import Button from '@components/ui/Button';
import MultiSelectAutocomplete from '@components/ui/MultiSelectAutocomplete';
import { listPermissions } from '@services/userService';
import { FormControlLabel, Checkbox } from '@mui/material';

export default function ProfileForm({ profile, onSave, onCancel }) {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    permission_ids: [],
    is_admin: false,
  });
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPermissions();
  }, []);

  useEffect(() => {
    if (profile) {
      setFormData({
        name: profile.name,
        description: profile.description,
        permission_ids: profile.permissions?.map(p => p.id) || [],
        is_admin: profile.is_admin || false,
      });
    }
  }, [profile]);

  const loadPermissions = async () => {
    try {
      const data = await listPermissions();
      setPermissions(data);
    } catch (error) {
      console.error('Erro ao carregar permissões:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handlePermissionsChange = (selectedPermissions) => {
    const permissionIds = selectedPermissions.map(name => {
      const perm = permissions.find(p => p.name === name);
      return perm?.id;
    }).filter(Boolean);
    setFormData(prev => ({ ...prev, permission_ids: permissionIds }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  const selectedPermissionNames = permissions
    .filter(p => formData.permission_ids.includes(p.id))
    .map(p => p.name);

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <Input
        label="Nome do Perfil"
        name="name"
        value={formData.name}
        onChange={handleChange}
        required
      />
      <Input
        label="Descrição"
        name="description"
        value={formData.description}
        onChange={handleChange}
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={formData.is_admin}
            onChange={handleChange}
            name="is_admin"
            color="primary"
          />
        }
        label="Perfil Administrador (acesso total)"
      />

      {!loading && (
        <MultiSelectAutocomplete
          label="Permissões"
          options={permissions.map(p => p.name)}
          value={selectedPermissionNames}
          onChange={handlePermissionsChange}
          placeholder="Selecione as permissões"
          disabled={formData.is_admin}
        />
      )}

      <div className="flex justify-end space-x-4">
        <Button type="button" variant="outline" onClick={onCancel}>Cancelar</Button>
        <Button type="submit" variant="primary">Salvar</Button>
      </div>
    </form>
  );
}